<template>
  <div id="contenedor-agregar-catalogo-localidad">
    <v-form v-model="formularioValido" ref="registrarCatalogoLocalidad">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nueva Localidad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            label="Municipio"
            v-model="catalogoLocalidad.idMunicipio"
            :items="listadoMunicipios"
            item-text="nombre"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required
          />
          <custom-text-field
            label="Descripción"
            v-model="catalogoLocalidad.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixCatalogoLocalidades from './mixCatalogoLocalidades';
import mixCatalogoMunicipios from '../municipios/mixCatalogoMunicipios';

export default {
  name: 'AgregarCatalogoLocalidad',
  mixins: [mixCatalogoLocalidades, mixCatalogoMunicipios],
  components: {
    CustomSelect,
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      catalogoLocalidad: {
        idMunicipio: null,
        descripcion: '',
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgregarCatalogoLocalidad().then(() => {
        this.cerrar();
      });
    },
    clearForm() {
      this.$refs.registrarCatalogoLocalidad.reset();
      this.$refs.registrarCatalogoLocalidad.resetValidation();
      this.catalogoLocalidad = {
        idMunicipio: null,
        descripcion: '',
      };
    },
    cerrar() {
      this.clearForm();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoMunicipios() {
      if (!this.municipios) {
        return [];
      }
      return this.municipios;
    },
  },
};
</script>

<style lang="scss">

</style>
